import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { ConsentCallbackComponent } from './features/admin/components/onboarding/consent-callback-component/consent-callback-component.component';
import { OnboardingComponent } from './features/admin/components/onboarding/onboarding.component';
import { TenantConsentComponent } from './features/admin/components/onboarding/tenant-consent/tenant-consent.component';
import { LandingRouteComponent } from './landing-route.component';
import { TenantSelectionRouteComponent } from './tenant-selection-route.component';

export const appRoutes: Routes = [
  {
    path: 'admin',
    canActivate: [MsalGuard],
    loadChildren: () => import('./features/admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'in',
    canActivate: [MsalGuard],
    loadChildren: () => import('./features/instance-admin/instance-admin.module').then((m) => m.InstanceAdminModule),
  },
  {
    path: 'onboarding/:id',
    component: OnboardingComponent,
  },
  {
    path: 'consent',
    component: TenantConsentComponent,
    pathMatch: 'full',
  },
  {
    path: 'consent-callback',
    component: ConsentCallbackComponent,
  },
  {
    path: 'user',
    canActivate: [MsalGuard],
    loadChildren: () => import('./features/user/user.module').then((m) => m.UserModule),
  },
  {
    path: 'tenant-selection',
    component: TenantSelectionRouteComponent,
    pathMatch: 'full',
  },
  {
    path: 'landing',
    component: LandingRouteComponent,
    pathMatch: 'full',
  },
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'landing',
  },
];
